export default __webpack_public_path__ + "static/media/roobert-regular-webfont.d088a1ad.ttf";